// extracted by mini-css-extract-plugin
export default {"addFolderModal":"addModal_addFolderModal__-SuLV","labelAndInput":"addModal_labelAndInput__Y+ygL","label":"addModal_label__fsRcj","input":"addModal_input__wB4ms"};